module.exports = __webpack_public_path__ + "img/smartcollege_ipad.f4571313.png";